/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { Button, Form, OverlayTrigger, Popover } from 'react-bootstrap';
import { PlusLg, Trash, QuestionCircle } from 'react-bootstrap-icons';
import { revisionFetchIsLoading, revisionFetchHasErrored, revision } from '../actions/actionCreator';
import { convertDiff, callGopher } from '../assets/js/gopher.js';
import ToolStatus from './ToolStatus';
import Loading from './Loading';

const mapStateToProps = (state, ownProps) => ({
  siteId: state.siteId,
  diff: ownProps.diff,
  undo: ownProps.undo,
  resFolder: state.openedFolder,
  resFile: state.openedFile,
  callDVS: ownProps.callDVS,
});

const mapDispatchToProps = (dispatch) => ({
  revisionFetchIsLoading: (isLoading) => dispatch(revisionFetchIsLoading(isLoading)),
  revisionFetchHasErrored: (hasErrored) => dispatch(revisionFetchHasErrored(hasErrored)),
  revision: (revisionLoaded) => dispatch(revision(revisionLoaded)),
});

class RepeatTool extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gopherReadyDiff: convertDiff(this.props.diff, this.props.undo),
      gopherMessage: '',
      sites: this.props.undo ? this.props.siteId : '',
      dvsMessage: '',
      gopherStatus: null,
      showLog: false,
      gopherPending: false,
      gopherSubheading: this.props.undo
        ? 'The change has been undone.'
        : 'The change has been successfully repeated across all sites on the list.',
      sitesInvalid: false,
      messageInvalid: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.doRepeat = this.doRepeat.bind(this);
  }

  validateInput = (e) => {
    e.preventDefault();
    if (this.state.sites === '') {
      this.setState({ sitesInvalid: true });
    } else if (this.state.dvsMessage === '') {
      this.setState({ messageInvalid: true });
    } else {
      this.doRepeat();
    }
  };

  doRepeat = () => {
    const gopherDataJson = {
      script_name: 'synch-config',
      script_params: {
        synch_xml: this.state.gopherReadyDiff.map((D) => D.value).join('').replace(/\r?\n|\r/g, '').replace(/"/g, "'"),
        site_ids: this.state.sites.replace(/ /g, '').split(','),
        dvs_message: this.state.dvsMessage,
      },
    };
    const gopherThen = (json) => {
      this.setState({
        gopherStatus: json.status === 'success' ? 'success' : 'danger',
        gopherMessage: 'No errors reported from script.',
        gopherPending: false,
      });
      this.props.callDVS(
        this.props.revisionFetchIsLoading,
        this.props.revisionFetchHasErrored,
        this.props.revision,
        'REVISION',
        this.props.siteId,
        this.props.resFolder,
        this.props.resFile,
      );
    };
    const gopherFail = (error) => {
      console.error(error);
      this.setState({
        gopherStatus: 'danger',
        gopherMessage: 'Could not connect to Gopher API',
        gopherPending: false,
      });
    };
    this.setState({ gopherPending: true });
    callGopher(gopherDataJson, gopherThen, gopherFail);
  };

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    const result = this.state.gopherReadyDiff.map((part, index) => {
      let addClass = '';
      if (!this.props.undo) {
        addClass = part.added ? 'add' : part.removed ? 'remove' : 'no_change';
      } else {
        addClass = part.added ? 'remove' : part.removed ? 'add' : 'no_change';
      }
      return (
        <div key={index} className={addClass}>
          {addClass === 'add' ? <PlusLg /> : <Trash />}
          <div>{part.value}</div>
        </div>
      );
    });
    const popoverLeft = (
      <Popover id="popover-positioned-left">
        <Popover.Header as="h3">What is a DVS Message?</Popover.Header>
        <Popover.Body>
          A brief message describing why you are making this change.{' '}
          <a target="_blank" rel="noreferrer" href="https://fuel.coxautoinc.com/docs/DOC-179945">More</a>
        </Popover.Body>
      </Popover>
    );
    return (
      <div className="repeatTool">
        {!this.state.gopherStatus && !this.state.gopherPending && (
          <div>
            <h5>Summary</h5>
            <pre className="summary">{result}</pre>
            <Form onSubmit={this.validateInput}>
              {!this.props.undo && (
                <Form.Group controlId="formControlsTextarea">
                  <Form.Label>Enter the sites you want to repeat this change on:</Form.Label>
                  <Form.Control
                    as="textarea"
                    name="sites"
                    isInvalid={this.state.sitesInvalid}
                    value={this.state.sites}
                    onChange={this.handleChange}
                    placeholder="siteId, siteId, siteId, ..."
                  />
                </Form.Group>
              )}
              <Form.Group controlId="formControlsTextarea2">
                <Form.Label>
                  Message{' '}
                  <OverlayTrigger trigger="click" placement="left" overlay={popoverLeft}>
                    <QuestionCircle role="button" />
                  </OverlayTrigger>
                </Form.Label>
                <Form.Control
                  as="textarea"
                  name="dvsMessage"
                  isInvalid={this.state.messageInvalid}
                  value={this.state.dvsMessage}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Button variant="primary" size="lg" type="submit" disabled={this.state.gopherPending}>
                {!this.props.undo && (
                  <span className="buttonText">Repeat<PlusLg /><PlusLg /><PlusLg /></span>
                )}
                {this.props.undo && (
                  <span className="buttonText">Undo<Trash /></span>
                )}
              </Button>
            </Form>
          </div>
        )}
        {this.state.gopherPending && (<Loading />)}
        {this.state.gopherStatus && (
          <ToolStatus
            status={this.state.gopherStatus}
            message={this.state.gopherMessage}
            subheading={this.state.gopherSubheading}
          />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RepeatTool);
